<template>


    <div class="container">
        <img src="/vf/images/about/donate_banner.png" style="border-radius: 1rem;" />
    </div>

    <!-- MAIN start -->
    <div class="section-title" style="margin-top: 2rem;max-width: 1280px;">
        <p style="font-size: medium;text-align: justify;">Vedanta P.G. Girls College, Reengus, empowers young women from
            rural Rajasthan through quality education in arts, science, and commerce. Our students shine both
            academically and in sports, bringing accolades to the college. By contributing to this cause, you help to
            continue empowering these dynamic young women to achieve even greater heights.
        </p>
        <p style="font-size: medium;text-align: justify;">
            Our college has been a guiding light for aspiring young women since its establishment in 1992. Serving as a
            vibrant hub of knowledge and growth, we have been instrumental in shaping the futures of over 37,000
            students from Reengus and the surrounding rural communities.
        </p>
    </div>

    <div class="section-title">
        <h2>Educational Sponsorship</h2>
    </div>

    <div class="row justify-content-center align-items-center">
        <div class="col-lg-7">
            <div class="single-news-card style3">
                <div class="row align-items-center">
                    <div class="col-lg-5 col-md-5">
                        <div class="news-img">
                            <a><img src="https://img.freepik.com/free-photo/mortarboard-diploma-grammar-books_23-2149436683.jpg"
                                    alt="Image"></a>
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7">
                        <div class="news-content">
                            <a href="#">
                            </a>
                            <p>The average cost to sponsor a student for an entire year is <strong>Rs.
                                    10,000/-</strong>, making a significant
                                impact on their education and future opportunities.</p>
                            <a href="https://rdc.eshala.co.in/page/donate" class="default-btn btn">Join the Movement<i
                                    class="flaticon-graduation"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade modal-xl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Payment Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6>** For an 80G receipt, send your name, donation amount, and email to
                        suresh@vedantafoundation.org
                    </h6>
                    <h6>** For more information on how you can join our mission write to us at
                        info@vedantafoundation.org
                    </h6>
                    <hr />
                    <div class="accordion" id="accordionExample">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    By Bank Transfer - Indian Citizen
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <table class="table table-striped">
                                        <tbody>
                                            <tr>
                                                <td>Bank Name </td>
                                                <td>ICICI Bank</td>
                                            </tr>
                                            <tr>
                                                <td>Favouring</td>
                                                <td>Vedanta Foundation</td>
                                            </tr>
                                            <tr>
                                                <td>A/C Type</td>
                                                <td>Saving Bank Account</td>
                                            </tr>
                                            <tr>
                                                <td>Account No.</td>
                                                <td>034801002732</td>
                                            </tr>
                                            <tr>
                                                <td>IFSC Code</td>
                                                <td>ICIC0000348</td>
                                            </tr>
                                            <tr>
                                                <td>Branch Address</td>
                                                <td>Shop No.2, Rawal Building 01, Dr Bhadkamkar Marg, Opera House Mumbai
                                                    - 400 004</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingTwo">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    By Bank Transfer - Foreign Citizen
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample">
                                <ul>
                                    <li>Foreign citizens/ passport holders of any country other than India can contact
                                        us.
                                    </li>
                                    <li>Indian passport holders with International Bank Accounts/ Cards can donate using
                                        below details</li>
                                </ul>
                                <div class="accordion-body">
                                    <table class="table table-striped">
                                        <tbody>
                                            <tr>
                                                <td>Bank Name </td>
                                                <td>SBI Bank</td>
                                            </tr>
                                            <tr>
                                                <td>In Name of</td>
                                                <td>Vedanta Foundation</td>
                                            </tr>
                                            <tr>
                                                <td>A/C Type</td>
                                                <td>Saving Bank Account</td>
                                            </tr>
                                            <tr>
                                                <td>Account No.</td>
                                                <td>40143090867</td>
                                            </tr>
                                            <tr>
                                                <td>Branch Code</td>
                                                <td>691</td>
                                            </tr>
                                            <tr>
                                                <td>IFSC Code</td>
                                                <td>SBIN0000691</td>
                                            </tr>
                                            <tr>
                                                <td>Swift</td>
                                                <td>SBININBB104</td>
                                            </tr>
                                            <tr>
                                                <td>Branch Address</td>
                                                <td>FCRA Cell, 4th Floor, State Bank of India, New Delhi Main Branch 11,
                                                    Sansad Marg, New Delhi - 110 001</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                    By Cheque/Draft
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        Please make your cheque/draft in the name of <strong>Vedanta Foundation</strong>
                                        and send it to
                                        Vedanta Foundation, Mittal Tower, Wing B, Office Number 56, Nariman Point,
                                        Mumbai - 400021, India
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingFour">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                    By UPI/GPay/PhonePe/QR code based payments
                                </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <span>
                                        <img src="/vf/images/about/qr_scanner.jpg" width="200px" height="200px" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link to="/newsletter" class="default-btn btn">Newsletter</router-link>
                    <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
    <!--End Bottom Connect Area -->


</template>

<script>
export default {
    name: "TopperView",
    data() {
        return {
            data: null,
            right_info: '',
            left_info: ''
        };
    },
    methods: {
        async fetchData() {

            const responseValue = await fetch("json/topper.json");
            this.data = await responseValue.json();
        }
    },
    mounted() {
        this.fetchData();
    },
};
</script>
